export default __webpack_public_path__ + "8cab37a7d9ae7bc0a79cd9681a464cc8.png";